import React from 'react'
import ChartFlexSection from '@components/chart/ChartFlexSection'
import { IResponseOptVendorNewAndOldLists } from '@interfaces/api/IDashboard'
import TextChartTitle from '@components/text/TextChartTitle'
import _ from 'lodash'
import { ThY } from '@utils/utils'
import { Card, Flex, List, Title } from '@mantine/core'

const VendorNewAndOldLists = ({ title, data }: { title: string; data: IResponseOptVendorNewAndOldLists }) => {
  const _data = _.groupBy(data, (a) => a.budget_year)
  const tableData = Object.keys(_data).map((year) => {
    const newAgencies: IResponseOptVendorNewAndOldLists = []
    const oldAgencies: IResponseOptVendorNewAndOldLists = []
    _data[year].forEach((list) => {
      if (list.vendor_type === 'new') newAgencies.push(list)
      else oldAgencies.push(list)
    })
    return { budget_year: year, newAgencies, oldAgencies }
  })
  return (
    <ChartFlexSection>
      <TextChartTitle>{title}</TextChartTitle>
      <Flex direction="column" gap="xl">
        {tableData.map((r) => (
          <div key={r.budget_year}>
            {tableData.length > 1 && <TextChartTitle mb="sm">{title + ' ประจำปีงบประมาณ ' + ThY(r.budget_year)} </TextChartTitle>}
            <Flex gap="md">
              <Card shadow="md" withBorder w="50%">
                <Title order={5} mb="sm">
                  ผู้ค้ารายเก่า
                </Title>
                <List type="ordered">
                  {r.oldAgencies.map((vendor, index) => (
                    <List.Item key={index}>{vendor.vendor_name}</List.Item>
                  ))}
                  {!r.oldAgencies.length && <div>ไม่มีข้อมูล</div>}
                </List>
              </Card>
              <Card shadow="md" withBorder w="50%">
                <Title order={5} mb="sm">
                  ผู้ค้ารายใหม่
                </Title>
                <List type="ordered">
                  {r.newAgencies.map((vendor, index) => (
                    <List.Item key={index}>{vendor.vendor_name}</List.Item>
                  ))}
                  {!r.newAgencies.length && <div>ไม่มีข้อมูล</div>}
                </List>
              </Card>
            </Flex>
          </div>
        ))}
      </Flex>
    </ChartFlexSection>
  )
}

export default VendorNewAndOldLists
